import { keepPreviousData } from '@tanstack/react-query';
import { PortfolioTabs } from '@unistocks/features/portfolios/components/portfolio-details/portfolio-tabs';
import { useSharedPortfolioHistory } from '@unistocks/features/portfolios/hooks/use-portfolio-history';
import { PortfolioDto, SharedPortfolioSettings } from '@unistocks/proxy/axios-client';
import { startOfYear, today, yesterday } from '@unistocks/shared/utils/util';
import { DateRange, Filter } from '@unistocks/types';
import { memo, useState } from 'react';

export type SharedPortfolioDetailsProps = {
  portfolio: PortfolioDto;
  settings: SharedPortfolioSettings;
};

export const SharedPortfolioDetails = memo<SharedPortfolioDetailsProps>(
  ({ portfolio, settings: { includeHistory, includeNominalValues } }) => {
    const { id } = portfolio;
    const [sectionFilter, setSectionFilter] = useState<Filter<string>>({
      type: 'exclude',
      values: []
    });
    const [assetFilter, setAssetFilter] = useState<Filter<string>>({ type: 'exclude', values: [] });
    const [[startDate, endDate], setDateRange] = useState<DateRange>([startOfYear(), today()]);

    const { data: portfolioHistory, isFetching: isLoadingPortfolioHistory } =
      useSharedPortfolioHistory(id, startDate, endDate, {
        enabled: includeHistory,
        placeholderData: keepPreviousData
      });

    const { data: todaysChange, isFetching: isLoadingTodaysChange } = useSharedPortfolioHistory(
      id,
      yesterday(),
      undefined,
      {
        enabled: includeHistory,
        placeholderData: keepPreviousData
      }
    );

    return (
      <PortfolioTabs
        portfolio={portfolio}
        portfolioHistory={portfolioHistory}
        isLoadingPortfolioHistory={isLoadingPortfolioHistory}
        todaysChange={todaysChange}
        todaysChangeLoading={isLoadingTodaysChange}
        assetFilter={assetFilter}
        setAssetFilter={setAssetFilter}
        sectionFilter={sectionFilter}
        setSectionFilter={setSectionFilter}
        setDateRange={setDateRange}
      />
    );
  }
);

SharedPortfolioDetails.displayName = 'PortfolioDetails';
